import { Node } from "@tiptap/core";

export const Placeholder = Node.create({
    name: "placeholder",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,

    addStorage() {
        return {
            previewMode: false,
            previewValues: {},
        };
    },

    addAttributes() {
        return {
            key: {
                default: null,
                parseHTML: (element) => element.getAttribute("data-ph"),
                renderHTML: (attributes) => (attributes.key ? { "data-ph": attributes.key } : {}),
            },
            label: {
                default: null,
                parseHTML: (element) => element.getAttribute("data-label") || element.innerText,
                renderHTML: (attributes) => (attributes.label ? { "data-label": attributes.label } : {}),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "span[data-ph]",
                getAttrs: (element) => {
                    const key = element.getAttribute("data-ph");
                    const label = element.getAttribute("data-label") || element.innerText;
                    return { key, label };
                },
            },
        ];
    },

    renderHTML({ node, HTMLAttributes }) {
        const key = node.attrs.key;
        const label = node.attrs.label || key;

        const previewMode = !!this.storage.previewMode;
        const previewValues = this.storage.previewValues || {};

        let displayValue = label;
        if (previewMode) {
            displayValue =
                previewValues[key] != null && previewValues[key] !== "" ? previewValues[key] : `[${label}]`;
        }

        return [
            "span",
            {
                ...HTMLAttributes,
                "data-label": label,
                class: "ph-badge",
                style: `background-color: ${previewMode ? "#f5f5f5" : "#e3f2fd"}; border: 1px solid ${
                    previewMode ? "#bdbdbd" : "#2196f3"
                }; border-radius: 4px; padding: 0 4px; margin: 0 2px; color: ${
                    previewMode ? "#616161" : "#0d47a1"
                }; font-family: monospace; font-weight: 500; cursor: default; user-select: none;`,
            },
            displayValue,
        ];
    },

    addCommands() {
        return {
            insertPlaceholder:
                (attributes) =>
                    ({ commands }) =>
                        commands.insertContent({ type: this.name, attrs: attributes }),

            setPlaceholderPreview:
                ({ previewMode, previewValues }) =>
                    ({ editor }) => {
                        const ext = editor.extensionManager.extensions.find((e) => e.name === this.name);
                        if (!ext) return false;
                        // storage is shared on the extension instance:
                        ext.storage.previewMode = !!previewMode;
                        ext.storage.previewValues = previewValues || {};
                        editor.view.dispatch(editor.state.tr); // re-render
                        return true;
                    },
        };
    },
});
